(() => {
  const targetHandle = 'vinativ®herbal-intimate-care-ph-balance-festigung-sanfte-hydratation';
  const currentHandle = decodeURIComponent(window.location.pathname).split('/products/')[1]?.replace(/\/$/, '');

  if (currentHandle !== targetHandle) return;

  const syncWidgetPrices = () => {
    document.querySelectorAll('[id^="appstle_subscription_widget"]').forEach((widget) => {
      const oneTimePrice = widget.querySelector(
        '.appstle_subscription_wrapper_option:not(.appstle_include_dropdown) .appstle_one_time_price_wrapper .appstle_subscription_amount'
      );
      const oneTimePriceMarkup = oneTimePrice?.innerHTML.trim();
      const oneTimePriceText = oneTimePrice?.textContent.trim();

      if (!oneTimePriceMarkup || !oneTimePriceText) return;

      widget
        .querySelectorAll(
          '.appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_subscription_compare_amount'
        )
        .forEach((comparePrice) => {
          if (comparePrice.innerHTML.trim() !== oneTimePriceMarkup) {
            comparePrice.innerHTML = oneTimePriceMarkup;
          }
        });

      widget
        .querySelectorAll(
          '.appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_subscription_compare_amount-appstle-sr-only'
        )
        .forEach((accessibleComparePrice) => {
          const accessibleText = `Original price ${oneTimePriceText}`;
          if (accessibleComparePrice.textContent.trim() !== accessibleText) {
            accessibleComparePrice.textContent = accessibleText;
          }
        });
    });
  };

  let animationFrame = 0;
  const scheduleSync = () => {
    if (animationFrame) return;

    animationFrame = window.requestAnimationFrame(() => {
      animationFrame = 0;
      syncWidgetPrices();
    });
  };

  const observer = new MutationObserver(scheduleSync);
  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true,
  });

  document.addEventListener('change', scheduleSync, true);
  document.addEventListener('input', scheduleSync, true);
  scheduleSync();
})();
